export default __webpack_public_path__ + "static/media/sahadevia-white-text.59be1255.png";